import Axios from 'axios';
import { getHeaders } from "../../utills";
import AlertAction from "../Actions/AlertActions";
import GeneralAction from "../Actions/GeneralAction";
import Apis from "../Apis";


class ContractorMiddleware {

    static getEmployeeWork = () => {
        return dispatch => {
            dispatch(GeneralAction.ShowLoading())
            return new Promise(async (resolve, reject) => {
                try {
                    const { data } = await Axios.get(
                        Apis.contractorDashboard,
                        {
                            headers: getHeaders()
                        }
                    )
                    if (data?.success) {
                        resolve(data)
                        dispatch(GeneralAction.HideLoading())
                    } else {
                        dispatch(GeneralAction.HideLoading())
                    }
                }
                catch (error) {
                    reject(error)
                    console.log(error.message)
                    dispatch(GeneralAction.HideLoading())
                    dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
                }
            })
        }
    }
}

export default ContractorMiddleware;